// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent_Container {
  width: 100%;
  min-height: 90vh;
  height: 100%;
}

.white_space {
  white-space: nowrap;
}

/* Header */
.header {
  background-color: #fff;
  padding: 1rem;
  width: 100%;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 10;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header .header-sidebar {
  padding: 1rem 2rem;
}

.header .header-sidebar h2 {
  text-align: left;
  cursor: pointer;
  font-size: 40px !important;
}

.header-search {
  width: 82%;
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-left: auto;
}

.header-search .input-header {
  width: 50%;
}

.search-input {
  font-size: 1.5rem;
  width: 100%;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Hamburger Icon (only visible on smaller screens) */
.hamburger-icon {
  font-size: 1.8rem;
  color: #333;
  cursor: pointer;
  display: none; /* Hide by default */
}

.hamburger-icon:hover {
  color: #007bff;
}

/* Sidebar */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  backdrop-filter: blur(2px);
}

.sidebar {
  background-color: #fff;
  position: fixed;
  padding: 1rem 2rem;
  left: 0;
  top: 6rem;
  height: calc(100vh - 6rem);
  overflow-y: auto;
  padding-bottom: 2rem;
  width: 300px;
  background: white;
  border-right: 1px solid #e5e7eb;
  z-index: 50;
}

.nav-links h2 {
  font-size: 25px;
}

.nav-links li {
  list-style-type: none;
  /* margin-top: 1rem; */
}

.nav-links li a {
  font-size: 28px;
  cursor: pointer;
}

.nav-links li a.active {
  font-weight: bold;
  color: #ff04b5;
}

.separator {
  border-bottom: 2px solid rgb(113, 109, 109);
  margin: 1rem 0;
}

/* Scroll indicator */
.scroll-indicator {
  position: absolute;
  bottom: 210px; /* Above the auth section */
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  z-index: 1001;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
}

.scroll-indicator.visible {
  opacity: 1;
  visibility: visible;
}

.scroll-indicator:hover {
  background: linear-gradient(135deg, #0056b3, #004085);
  transform: translateX(-50%) scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.scroll-indicator svg {
  color: white;
  font-size: 16px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
  60% {
    transform: translateY(-2px);
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.sidebar-left {
  animation: slideInLeft 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 250px;
  height: 100vh;
  padding: 0 2rem 1rem 2rem;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  border-bottom: 1px solid #e9ecef;
  z-index: 1000;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
}

.sidebar-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sidebar-content::-webkit-scrollbar {
  display: none;
}

.sidebar-content::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 2px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

/* Navigation sections */
.sidebar-nav-section {
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-nav-section:last-child {
  border-bottom: none;
}

.sidebar-left h3 {
  margin-top: 0;
  font-size: 1.5rem;
}

.sidebar-left ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-left ul li {
  margin-bottom: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.sidebar-left ul li:hover {
  color: #007bff;
}

.sidebar-left ul li p.active,
.sidebar-left ul li a.active {
  background-color: #e3f2fd;
  color: #007bff;
  border-left-color: #007bff;
  font-weight: 600;
}

.sidebar-left .icon-cross {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-left .icon-cross h2 {
  cursor: pointer;
  margin-top: 1.5rem;
}

.sidebar-close-icon {
  font-size: 16px;
  color: black;
  cursor: pointer;
}

/* footer */
.footer {
  background-color: #fff;
  color: black;
  padding: 25px;
  text-align: center;
  width: 100%;
  font-size: larger;
}

.content_wrapper {
  margin: 0 auto;
  margin-top: 6rem;
  padding: 1rem;
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-direction: row;
}

.content_wrapper .content_wrapper_child {
  width: 100%;
  min-height: 75vh;
  height: 100%;
  overflow-y: auto;
  padding-right: 0;
}

.home_container {
  margin-left: 20rem;
  width: 100%;
  height: 80vh;
}

.home_container img {
  /* margin-left: 3rem; */
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* product */
.product_container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  padding: 1rem;
  width: 100%;
}

.modal-backdrop.blur_backdrop {
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.4); /* Optional: darken the blur */
}

/* Cart style */
.cart {
  position: relative;
  width: 100%;
  height: auto;
  /* border: 1px solid #ddd; */
  transition: transform 0.3s ease;
}

.cart-detail {
  width: 100%;
  height: auto;
  max-width: 600px;
  margin: 1rem auto;
}

/* Image container */
.image_container {
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}
.image_container > img {
  width: 100%;
  height: 100%;
  aspect-ratio: 0.67;
  object-fit: cover;
}
.image {
  width: 100%;
  height: 30rem;
  object-fit: cover;
  /* border: #ddd 1px solid; */
  aspect-ratio: 0.67;
}

/* Default image */
.defaultImage {
  width: 100%;
  height: 600px;
  object-fit: cover;
  opacity: 1;
  transition: opacity 0.3s ease;
  position: relative;
  z-index: 1;
}

/* MSR Category */
.msr_container {
  padding: 0.5rem;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  width: 15em;
  overflow: hidden;
}

/* Hover text */
.hoverText {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.8); /* Slightly darker for better visibility */
  color: white;
  font-size: 1rem;
  text-align: center;
  opacity: 0;
  z-index: 3; /* Ensure it appears above images */
  transform: translateY(100%);
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* Show hover text on hover */
.image_container:hover .hoverText {
  opacity: 1;
  transform: translateY(0);
}

/* Cart color details */
.cart_color {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
}

/* Cart details text */
.cart p {
  margin: 0.5rem 0;
}

/* Search Results Specific Styles */
.search-results-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  background-color: #f9f9f9;
}

.search-results-header h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.search-results-header p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.product-name {
  padding: 8px;
  text-align: center;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  border-top: 1px solid #f0f0f0;
  background-color: #fafafa;
}

/* categotry */
.category-container {
  display: flex;
  align-items: center;
  position: relative;
}

.category-container .left {
  font-size: 28px;
}

.category-container .right {
  font-size: 28px;
}

.category {
  display: flex;
  gap: 1rem;
  padding: 0;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  max-width: 100%;
  align-items: center;
}

.category::-webkit-scrollbar {
  display: none;
}

.category .filter-btn {
  background: none;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  padding: 5px 10px;
  cursor: pointer;
  transition: color 0.3s ease;
  border: none;
  flex-shrink: 0;
}

.category .filter-btn.active {
  font-weight: bold;
  text-decoration: underline;
  color: #cd0d0d;
}

.category .filter-btn:hover {
  color: #cd0d0d;
}

/* pagination  */
.pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px;
}

.pagination-container {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding: 0 8px;
}

.pagination-pages {
  display: flex;
  align-items: center;
  gap: 2px;
  /* flex: 1; */
  justify-content: center;
  min-width: 0;
}

.pagination-button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 44px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f9f9f9;
}

.pagination-page.active-page {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination-button:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #999;
}

.pagination-page {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-page:hover {
  background-color: #f5f5f5;
  border-color: #999;
}

.pagination-page.active-page {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination-ellipsis {
  padding: 8px 4px;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
}

.pagination-info {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 4px;
}

/* Product Detail Page */
.product_detail {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 2rem;
  margin-top: 1rem;
  padding: 0 1rem;
}

/* Image and Description Container */
.image_description_container {
  display: flex;
  gap: 2rem;
  width: 100%;
  height: auto;
}

/* Image Container */
.image_container_detail {
  flex: 0.5 1;
  max-width: 800px;
  margin: 0 auto;
}

.large_image {
  width: 100%;
  height: auto;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
  margin-bottom: 1rem;
  aspect-ratio: 0.67;
}

.image_container_thumbnails {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.small_image {
  width: 100px;
  height: 100px;
  object-fit: cover;

  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 2px solid transparent;
}

.small_image:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border-color: #3498db;
}

/* Product Description */
.product_details_container {
  flex: 1 1;
  padding: 1rem;
}

.product_details_container h1 {
  font-size: 30px;
  color: #333;
}

.product_details_container h3 {
  font-size: 18px;
  color: #555;
}

/* not found product */
.no-products {
  font-size: 30px;
}

/* .cart .image_container > div {
  margin-top: 2rem;
  padding: 0 1.5rem;
} */

.image-detail {
  display: flex;
  justify-content: space-between;
}

.image-detail p {
  font-size: 1.5rem;
  font-weight: bold;
}

/* Responsive Design */

/* Loader */
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

/* loading  */
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

/* breadcrumb */
.breadcrumb {
  margin-top: 20px;
}

.breadcrumb span {
  color: #333;
  font-size: 20px;
  transition: color 0.3s ease;
  cursor: pointer;
}

/* heart */
.product-parent-heart {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* Small Heart in Top-Right Corner */
.heart-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2rem;
  color: grey;
  transition: color 0.3s;
}

.heart-icon-header {
  position: absolute;
  right: 8rem;
  bottom: 1rem;
  font-size: 2rem;
  color: grey;
  transition: color 0.3s;
  color: red;
  cursor: pointer;
  margin-bottom: 2rem !important;
}

.login {
  cursor: pointer;
}
.button {
  background-color: #558eca;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
}

.heart-icon.liked {
  color: red;
}

.heart-size.liked {
  color: red;
}

.heart-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  font-size: 4rem;
  color: red;
  opacity: 1;
  animation: fadeOut 1s ease-in-out;
}

.heart-size {
  font-size: 50px;
  color: grey;
  cursor: pointer;
}

.android-instructions {
  text-align: center;
  background: #f0f8ff;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
}

.android-instructions p {
  margin: 0 0 10px 0;
  color: #333;
}

.android-instructions p:first-child {
  font-weight: 600;
  margin-bottom: 15px;
}

/* Fading out effect */
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

@media (max-width: 1500px) {
  .product_container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 1399.98px) {
  .product_container {
    display: grid;
    /* grid-template-columns: 1fr 1fr; */
  }
}

@media (max-width: 1199.98px) {
  .heart-icon-header {
    right: 11rem;
    bottom: 3rem;
  }
}

@media (max-width: 991.98px) {
}

@media (max-width: 767.98px) {
  .hamburger-icon {
    display: block;
  }
  .login {
    display: none;
  }
  .header {
    display: block;
  }

  .home_container {
    margin-left: 0;
    margin-top: 4rem;
  }

  .header-search {
    margin-left: 0;
  }
  .header h2 {
    text-align: left;
    margin-bottom: 1.5rem;
  }

  .header-search .input-header {
    width: 100%;
  }

  .sidebar {
    border-radius: 0;
    display: none;
  }

  .header-sidebar {
    display: none;
  }

  .search-input {
    font-size: 1rem;
  }

  .cart-detail {
    width: 400px;
    height: auto;
  }

  .image_container_detail {
    width: auto;
  }

  .product-parent-heart .heart-icon {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    cursor: pointer;
    opacity: 0.5;
  }

  .heart-icon-header {
    position: static;
    bottom: 0;
    margin-bottom: 0 !important;
  }
  .image_container > img {
    width: 100%;
    height: auto;
    aspect-ratio: 0.67;
  }
  .product_container {
    display: grid;
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  .content_wrapper {
    padding: 0.5rem !important;
    margin: 1rem auto;
    gap: 1rem;
  }

  /* .pagination-pages {
    flex: 1;
  } */

  .product_detail {
    padding: 0;
    margin-top: 0.5rem;
  }

  .image_description_container {
    flex-direction: column;
    gap: 1rem;
  }

  .image_container_detail {
    width: 100%;
    max-width: none;
  }

  .large_image {
    margin-bottom: 0.5rem;
    box-shadow: none;
  }

  .product_details_container {
    padding: 0.5rem;
  }

  .product_details_container h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .product_container {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 0.5rem;
  }

  .cart-detail {
    width: 100%;
    margin: 0.5rem 0;
  }

  .image_container > img {
    aspect-ratio: 0.67;
    object-fit: cover;
  }

  /* Heart icon adjustments for mobile */
  .heart-icon {
    font-size: 1.5rem;
    top: 0.5rem;
    right: 0.5rem;
  }

  .heart-effect {
    font-size: 3rem;
  }

  .heart-size {
    font-size: 2rem;
  }
}

@media (max-width: 1024px) {
  .image_description_container {
    flex-direction: column;
  }

  .image_container_detail {
    width: 100%;
    margin: 0;
  }

  .product_details_container {
    width: 100%;
    padding: 1rem 0;
  }
}

@media (max-width: 768px) {
  .large_image {
    max-width: 100%;
  }

  .small_image {
    width: 80px;
    height: 80px;
  }

  .image_description_container {
    flex-direction: column;
    align-items: center;
  }

  .image {
    height: auto;
  }

  .header-search {
    width: auto;
  }
  .sidebar-left ul {
    margin-top: 1.5rem;
  }
  .product_container {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .cart-detail {
    max-width: 100%;
  }

  .product_detail {
    padding: 0 0.5rem;
  }
}

/* dummy image text  */
.image-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.image-not-found-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  padding: 12px 20px;
  border-radius: 4px;
  pointer-events: none;
}

.image-not-found-text {
  color: white;
  font-size: 30px;
  font-weight: 500;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .product_container {
    grid-template-columns: 1fr;
  }

  .product_details_container h1 {
    font-size: 24px;
  }

  .heart-icon {
    font-size: 1.5rem;
  }
}

@media (max-width: 375px) {
  .content_wrapper {
    padding: 0.25rem !important;
  }

  .product_details_container h1 {
    font-size: 1.25rem;
  }

  .heart-icon {
    font-size: 1.25rem;
  }
}

@media (max-width: 1024px) {
  .content_wrapper {
    padding: 0.75rem;
  }

  .product_container {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

@media (max-width: 768px) {
  .content_wrapper {
    padding: 0.5rem;
    flex-direction: column;
  }

  .product_container {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 0.75rem;
    padding: 0.5rem;
  }

  /* .cart {
    border-width: 1px;
  } */
}

@media (max-width: 480px) {
  .content_wrapper {
    margin: 0.5rem auto;
    padding: 0.25rem;
  }

  .product_container {
    grid-template-columns: repeat(1, 1fr);
    gap: 0.5rem;
    padding: 0.25rem;
  }
}

.not-found-page header {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa,EAAE,oBAAoB;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa,EAAE,2BAA2B;EAC1C,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;;;;;IAKE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAIhC,eAAe;EACf,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAdlB;;AAiBA;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC,EAAE,8BAA8B;AACtE;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,8BAA8B,EAAE,0CAA0C;EAC1E,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU,EAAE,mCAAmC;EAC/C,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;;EAEjB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;;AAEtB,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,UAAU;EACV,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,aAAa;IACb,kCAAkC;EACpC;AACF;AACA;EACE;IACE,aAAa;IACb,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;AACA;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA;AACA;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,SAAS;EACX;;EAEA;;KAEG;;EAEH;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,2DAA2D;EAC7D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,4DAA4D;IAC5D,YAAY;IACZ,eAAe;EACjB;;EAEA;;KAEG;AACL;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf","sourcesContent":[".parent_Container {\n  width: 100%;\n  min-height: 90vh;\n  height: 100%;\n}\n\n.white_space {\n  white-space: nowrap;\n}\n\n/* Header */\n.header {\n  background-color: #fff;\n  padding: 1rem;\n  width: 100%;\n  display: flex;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header .header-sidebar {\n  padding: 1rem 2rem;\n}\n\n.header .header-sidebar h2 {\n  text-align: left;\n  cursor: pointer;\n  font-size: 40px !important;\n}\n\n.header-search {\n  width: 82%;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  margin-left: auto;\n}\n\n.header-search .input-header {\n  width: 50%;\n}\n\n.search-input {\n  font-size: 1.5rem;\n  width: 100%;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n/* Hamburger Icon (only visible on smaller screens) */\n.hamburger-icon {\n  font-size: 1.8rem;\n  color: #333;\n  cursor: pointer;\n  display: none; /* Hide by default */\n}\n\n.hamburger-icon:hover {\n  color: #007bff;\n}\n\n/* Sidebar */\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 20;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  backdrop-filter: blur(2px);\n}\n\n.sidebar {\n  background-color: #fff;\n  position: fixed;\n  padding: 1rem 2rem;\n  left: 0;\n  top: 6rem;\n  height: calc(100vh - 6rem);\n  overflow-y: auto;\n  padding-bottom: 2rem;\n  width: 300px;\n  background: white;\n  border-right: 1px solid #e5e7eb;\n  z-index: 50;\n}\n\n.nav-links h2 {\n  font-size: 25px;\n}\n\n.nav-links li {\n  list-style-type: none;\n  /* margin-top: 1rem; */\n}\n\n.nav-links li a {\n  font-size: 28px;\n  cursor: pointer;\n}\n\n.nav-links li a.active {\n  font-weight: bold;\n  color: #ff04b5;\n}\n\n.separator {\n  border-bottom: 2px solid rgb(113, 109, 109);\n  margin: 1rem 0;\n}\n\n/* Scroll indicator */\n.scroll-indicator {\n  position: absolute;\n  bottom: 210px; /* Above the auth section */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\n  z-index: 1001;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.scroll-indicator.visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.scroll-indicator:hover {\n  background: linear-gradient(135deg, #0056b3, #004085);\n  transform: translateX(-50%) scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);\n}\n\n.scroll-indicator svg {\n  color: white;\n  font-size: 16px;\n  animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-4px);\n  }\n  60% {\n    transform: translateY(-2px);\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.sidebar-left {\n  animation: slideInLeft 0.3s ease;\n}\n\n.sidebar-left {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #fff;\n  width: 250px;\n  height: 100vh;\n  padding: 0 2rem 1rem 2rem;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sidebar-header {\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  border-bottom: 1px solid #e9ecef;\n  z-index: 1000;\n  padding: 1.5rem 1.5rem 1rem 1.5rem;\n}\n\n.sidebar-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.sidebar-content::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 2px;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb:hover {\n  background-color: #999;\n}\n\n/* Navigation sections */\n.sidebar-nav-section {\n  padding: 1rem 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.sidebar-nav-section:last-child {\n  border-bottom: none;\n}\n\n.sidebar-left h3 {\n  margin-top: 0;\n  font-size: 1.5rem;\n}\n\n.sidebar-left ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-left ul li {\n  margin-bottom: 1rem;\n  font-size: 2rem;\n  cursor: pointer;\n}\n\n.sidebar-left ul li:hover {\n  color: #007bff;\n}\n\n.sidebar-left ul li p.active,\n.sidebar-left ul li a.active {\n  background-color: #e3f2fd;\n  color: #007bff;\n  border-left-color: #007bff;\n  font-weight: 600;\n}\n\n.sidebar-left .icon-cross {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-left .icon-cross h2 {\n  cursor: pointer;\n  margin-top: 1.5rem;\n}\n\n.sidebar-close-icon {\n  font-size: 16px;\n  color: black;\n  cursor: pointer;\n}\n\n/* footer */\n.footer {\n  background-color: #fff;\n  color: black;\n  padding: 25px;\n  text-align: center;\n  width: 100%;\n  font-size: larger;\n}\n\n.content_wrapper {\n  margin: 0 auto;\n  margin-top: 6rem;\n  padding: 1rem;\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  flex-direction: row;\n}\n\n.content_wrapper .content_wrapper_child {\n  width: 100%;\n  min-height: 75vh;\n  height: 100%;\n  overflow-y: auto;\n  padding-right: 0;\n}\n\n.home_container {\n  margin-left: 20rem;\n  width: 100%;\n  height: 80vh;\n}\n\n.home_container img {\n  /* margin-left: 3rem; */\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* product */\n.product_container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  width: 100%;\n}\n\n.modal-backdrop.blur_backdrop {\n  backdrop-filter: blur(10px);\n  background-color: rgba(0, 0, 0, 0.4); /* Optional: darken the blur */\n}\n\n/* Cart style */\n.cart {\n  position: relative;\n  width: 100%;\n  height: auto;\n  /* border: 1px solid #ddd; */\n  transition: transform 0.3s ease;\n}\n\n.cart-detail {\n  width: 100%;\n  height: auto;\n  max-width: 600px;\n  margin: 1rem auto;\n}\n\n/* Image container */\n.image_container {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n}\n.image_container > img {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 0.67;\n  object-fit: cover;\n}\n.image {\n  width: 100%;\n  height: 30rem;\n  object-fit: cover;\n  /* border: #ddd 1px solid; */\n  aspect-ratio: 0.67;\n}\n\n/* Default image */\n.defaultImage {\n  width: 100%;\n  height: 600px;\n  object-fit: cover;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n/* MSR Category */\n.msr_container {\n  padding: 0.5rem;\n  cursor: pointer;\n  font-size: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  width: 15em;\n  overflow: hidden;\n}\n\n/* Hover text */\n.hoverText {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0.5rem;\n  background: rgba(0, 0, 0, 0.8); /* Slightly darker for better visibility */\n  color: white;\n  font-size: 1rem;\n  text-align: center;\n  opacity: 0;\n  z-index: 3; /* Ensure it appears above images */\n  transform: translateY(100%);\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n/* Show hover text on hover */\n.image_container:hover .hoverText {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Cart color details */\n.cart_color {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n}\n\n/* Cart details text */\n.cart p {\n  margin: 0.5rem 0;\n}\n\n/* Search Results Specific Styles */\n.search-results-header {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  background-color: #f9f9f9;\n}\n\n.search-results-header h1 {\n  font-size: 24px;\n  margin-bottom: 10px;\n  color: #333;\n  font-weight: 600;\n}\n\n.search-results-header p {\n  color: #666;\n  font-size: 16px;\n  margin: 0;\n}\n\n.product-name {\n  padding: 8px;\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n  border-top: 1px solid #f0f0f0;\n  background-color: #fafafa;\n}\n\n/* categotry */\n.category-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.category-container .left {\n  font-size: 28px;\n}\n\n.category-container .right {\n  font-size: 28px;\n}\n\n.category {\n  display: flex;\n  gap: 1rem;\n  padding: 0;\n  overflow-x: auto;\n  white-space: nowrap;\n  scrollbar-width: none;\n  max-width: 100%;\n  align-items: center;\n}\n\n.category::-webkit-scrollbar {\n  display: none;\n}\n\n.category .filter-btn {\n  background: none;\n  font-size: 20px;\n  font-weight: 500;\n  color: #000;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  border: none;\n  flex-shrink: 0;\n}\n\n.category .filter-btn.active {\n  font-weight: bold;\n  text-decoration: underline;\n  color: #cd0d0d;\n}\n\n.category .filter-btn:hover {\n  color: #cd0d0d;\n}\n\n/* pagination  */\n.pagination {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 16px;\n}\n\n.pagination-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: nowrap;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  padding: 0 8px;\n}\n\n.pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  /* flex: 1; */\n  justify-content: center;\n  min-width: 0;\n}\n\n.pagination-button {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #333;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  min-width: 44px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f9f9f9;\n}\n\n.pagination-page.active-page {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: #f5f5f5;\n  border-color: #999;\n}\n\n.pagination-page {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #333;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-page:hover {\n  background-color: #f5f5f5;\n  border-color: #999;\n}\n\n.pagination-page.active-page {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.pagination-ellipsis {\n  padding: 8px 4px;\n  color: #666;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n}\n\n.pagination-info {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  margin-top: 4px;\n}\n\n/* Product Detail Page */\n.product_detail {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 2rem;\n  margin-top: 1rem;\n  padding: 0 1rem;\n}\n\n/* Image and Description Container */\n.image_description_container {\n  display: flex;\n  gap: 2rem;\n  width: 100%;\n  height: auto;\n}\n\n/* Image Container */\n.image_container_detail {\n  flex: 0.5;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.large_image {\n  width: 100%;\n  height: auto;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */\n  margin-bottom: 1rem;\n  aspect-ratio: 0.67;\n}\n\n.image_container_thumbnails {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.small_image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n\n  border-radius: 5px;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.small_image:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  border-color: #3498db;\n}\n\n/* Product Description */\n.product_details_container {\n  flex: 1;\n  padding: 1rem;\n}\n\n.product_details_container h1 {\n  font-size: 30px;\n  color: #333;\n}\n\n.product_details_container h3 {\n  font-size: 18px;\n  color: #555;\n}\n\n/* not found product */\n.no-products {\n  font-size: 30px;\n}\n\n/* .cart .image_container > div {\n  margin-top: 2rem;\n  padding: 0 1.5rem;\n} */\n\n.image-detail {\n  display: flex;\n  justify-content: space-between;\n}\n\n.image-detail p {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n/* Responsive Design */\n\n/* Loader */\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n}\n\n/* loading  */\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n}\n\n/* breadcrumb */\n.breadcrumb {\n  margin-top: 20px;\n}\n\n.breadcrumb span {\n  color: #333;\n  font-size: 20px;\n  transition: color 0.3s ease;\n  cursor: pointer;\n}\n\n/* heart */\n.product-parent-heart {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n/* Small Heart in Top-Right Corner */\n.heart-icon {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  font-size: 2rem;\n  color: grey;\n  transition: color 0.3s;\n}\n\n.heart-icon-header {\n  position: absolute;\n  right: 8rem;\n  bottom: 1rem;\n  font-size: 2rem;\n  color: grey;\n  transition: color 0.3s;\n  color: red;\n  cursor: pointer;\n  margin-bottom: 2rem !important;\n}\n\n.login {\n  cursor: pointer;\n}\n.button {\n  background-color: #558eca;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n}\n\n.heart-icon.liked {\n  color: red;\n}\n\n.heart-size.liked {\n  color: red;\n}\n\n.heart-effect {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1);\n  font-size: 4rem;\n  color: red;\n  opacity: 1;\n  animation: fadeOut 1s ease-in-out;\n}\n\n.heart-size {\n  font-size: 50px;\n  color: grey;\n  cursor: pointer;\n}\n\n.android-instructions {\n  text-align: center;\n  background: #f0f8ff;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.android-instructions p {\n  margin: 0 0 10px 0;\n  color: #333;\n}\n\n.android-instructions p:first-child {\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n/* Fading out effect */\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: translate(-50%, -50%) scale(1.2);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(1.5);\n  }\n}\n\n@media (max-width: 1500px) {\n  .product_container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media (max-width: 1399.98px) {\n  .product_container {\n    display: grid;\n    /* grid-template-columns: 1fr 1fr; */\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .heart-icon-header {\n    right: 11rem;\n    bottom: 3rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n}\n\n@media (max-width: 767.98px) {\n  .hamburger-icon {\n    display: block;\n  }\n  .login {\n    display: none;\n  }\n  .header {\n    display: block;\n  }\n\n  .home_container {\n    margin-left: 0;\n    margin-top: 4rem;\n  }\n\n  .header-search {\n    margin-left: 0;\n  }\n  .header h2 {\n    text-align: left;\n    margin-bottom: 1.5rem;\n  }\n\n  .header-search .input-header {\n    width: 100%;\n  }\n\n  .sidebar {\n    border-radius: 0;\n    display: none;\n  }\n\n  .header-sidebar {\n    display: none;\n  }\n\n  .search-input {\n    font-size: 1rem;\n  }\n\n  .cart-detail {\n    width: 400px;\n    height: auto;\n  }\n\n  .image_container_detail {\n    width: auto;\n  }\n\n  .product-parent-heart .heart-icon {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    font-size: 1.5rem;\n    cursor: pointer;\n    opacity: 0.5;\n  }\n\n  .heart-icon-header {\n    position: static;\n    bottom: 0;\n    margin-bottom: 0 !important;\n  }\n  .image_container > img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 0.67;\n  }\n  .product_container {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 575.98px) {\n}\n\n@media (max-width: 767.98px) {\n  .content_wrapper {\n    padding: 0.5rem !important;\n    margin: 1rem auto;\n    gap: 1rem;\n  }\n\n  /* .pagination-pages {\n    flex: 1;\n  } */\n\n  .product_detail {\n    padding: 0;\n    margin-top: 0.5rem;\n  }\n\n  .image_description_container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .image_container_detail {\n    width: 100%;\n    max-width: none;\n  }\n\n  .large_image {\n    margin-bottom: 0.5rem;\n    box-shadow: none;\n  }\n\n  .product_details_container {\n    padding: 0.5rem;\n  }\n\n  .product_details_container h1 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .product_container {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    padding: 0.5rem;\n  }\n\n  .cart-detail {\n    width: 100%;\n    margin: 0.5rem 0;\n  }\n\n  .image_container > img {\n    aspect-ratio: 0.67;\n    object-fit: cover;\n  }\n\n  /* Heart icon adjustments for mobile */\n  .heart-icon {\n    font-size: 1.5rem;\n    top: 0.5rem;\n    right: 0.5rem;\n  }\n\n  .heart-effect {\n    font-size: 3rem;\n  }\n\n  .heart-size {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .image_description_container {\n    flex-direction: column;\n  }\n\n  .image_container_detail {\n    width: 100%;\n    margin: 0;\n  }\n\n  .product_details_container {\n    width: 100%;\n    padding: 1rem 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .large_image {\n    max-width: 100%;\n  }\n\n  .small_image {\n    width: 80px;\n    height: 80px;\n  }\n\n  .image_description_container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .image {\n    height: auto;\n  }\n\n  .header-search {\n    width: auto;\n  }\n  .sidebar-left ul {\n    margin-top: 1.5rem;\n  }\n  .product_container {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  }\n\n  .cart-detail {\n    max-width: 100%;\n  }\n\n  .product_detail {\n    padding: 0 0.5rem;\n  }\n}\n\n/* dummy image text  */\n.image-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.image-not-found-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 12px 20px;\n  border-radius: 4px;\n  pointer-events: none;\n}\n\n.image-not-found-text {\n  color: white;\n  font-size: 30px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n@media (max-width: 480px) {\n  .product_container {\n    grid-template-columns: 1fr;\n  }\n\n  .product_details_container h1 {\n    font-size: 24px;\n  }\n\n  .heart-icon {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .content_wrapper {\n    padding: 0.25rem !important;\n  }\n\n  .product_details_container h1 {\n    font-size: 1.25rem;\n  }\n\n  .heart-icon {\n    font-size: 1.25rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .content_wrapper {\n    padding: 0.75rem;\n  }\n\n  .product_container {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .content_wrapper {\n    padding: 0.5rem;\n    flex-direction: column;\n  }\n\n  .product_container {\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 0.75rem;\n    padding: 0.5rem;\n  }\n\n  /* .cart {\n    border-width: 1px;\n  } */\n}\n\n@media (max-width: 480px) {\n  .content_wrapper {\n    margin: 0.5rem auto;\n    padding: 0.25rem;\n  }\n\n  .product_container {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 0.5rem;\n    padding: 0.25rem;\n  }\n}\n\n.not-found-page header {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
